import { Map } from 'immutable';

import * as types from '../actions/action_types';
import { StoreRecord } from '../records/store_records.js';
import { setValue, setError, setPending } from './helpers.js';

const initialState = Map({
  dashboardData: new StoreRecord(),
});

export default (state = initialState, action) => {
  switch(action.type) {
    case types.DASHBOARD_PENDING:
      return setPending(state, ['dashboardData']);

    case types.DASHBOARD_LOADED:
      return setValue(state, ['dashboardData'], action.data);

    case types.DASHBOARD_ERROR:
      return setError(state, ['dashboardData'], action.errorMessage);
  }
  return state;
};
